import React from 'react';
import { TaskType } from '@scale/shared-types';
import { isChatExperimentalTaskType } from './utils';
import {
  ChatBulkAuditChatRendererProps,
  ChatBulkAuditChatRendererPropsV2,
} from './chatBulkAuditChatRendererProps';
import { ChatBulkAuditChatRendererV1 } from './ChatBulkAuditChatRendererV1';
import ChatBulkAuditChatRendererV2 from './ChatBulkAuditChatRendererV2';

/**
 * Main chat renderer component that routes to the appropriate renderer based on task type
 */
export const ChatBulkAuditChatRenderer: React.FC<ChatBulkAuditChatRendererProps> = props => {
  if (isChatExperimentalTaskType(props.taskType)) {
    return (
      <ChatBulkAuditChatRendererV2
        key={props.auditAttemptId}
        {...(props as ChatBulkAuditChatRendererPropsV2)}
      />
    );
  }

  if (props.taskType === TaskType.Chat) {
    return <ChatBulkAuditChatRendererV1 {...props} />;
  }

  return null;
};
